export default __webpack_public_path__ + "static/media/ico-glass.c64f6080.svg";